import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'


//import Vuetify from 'vuetify' // Import Vuetify to your project
import 'vuetify/dist/vuetify.min.css'

// Helpers
import colors from 'vuetify/es5/util/colors'


Vue.use(Vuetify,{
  theme: {
    primary: '#1e88e5', // #1e88e5
    // secondary: '#1e88e5', // #1e88e5
    // accent: '#BDBDBD'// #67757c
  },
  options: {
    customProperties: true
  },
   iconfont: 'md',
}) // Add Vuetify as a plugin
